export const version = 'v4.0.3-alpha.12';
//# sourceMappingURL=version.js.map